import React from "react";
import styles from "./CartTable.module.css";

import { withStyles, makeStyles } from "@material-ui/core/styles";
import DeleteIcon from "@material-ui/icons/Delete";
import RemoveIcon from "@material-ui/icons/Remove";
import AddIcon from "@material-ui/icons/Add";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchDeCreateCountByID,
  fetchDeleteToCartInLocalStorageByID,
  fetchInCreateCountByID,
} from "redux/ActionCreators/CartActionCreators";
import {
  Button,
  Grid,
  IconButton,
  InputBase,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@material-ui/core";
import toVND from "shared/func/toVND";

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#000",
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const CartTable = (props) => {
  const { handelDataSubmit } = props;
  const dispatch = useDispatch();

  const carts = useSelector((state) => state.carts.listInLocalStorage);

  const handelDeleteCartByID = (id) => {
    dispatch(fetchDeleteToCartInLocalStorageByID(id));
  };

  const handelInCreateByID = (id) => {
    dispatch(fetchInCreateCountByID(id));
  };

  const handelDeCreateByID = (id) => {
    dispatch(fetchDeCreateCountByID(id));
  };

  const handleSubmit = () => {
    handelDataSubmit();
  };
  if (!carts) return <div>Loading...</div>;
  if (!carts.length) {
    return (
      <Typography
        variant="body1"
        gutterBottom
        style={{ textAlign: "center", marginTop: "30px" }}
      >
        Oops!!! Chưa có sản phẩm nào trong giỏ hàng...
      </Typography>
    );
  }
  return (
    <div className={styles.container}>
      <TableContainer component={Paper}>
        <Table className={styles.table} aria-label="customized table">
          <TableHead className={styles.table_header}>
            <TableRow>
              <StyledTableCell>Delete</StyledTableCell>
              <StyledTableCell align="center">Product</StyledTableCell>
              <StyledTableCell>Title</StyledTableCell>
              <StyledTableCell align="center">Price</StyledTableCell>
              <StyledTableCell align="center">Quantity</StyledTableCell>
              <StyledTableCell align="left">Subtotal</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {carts.map((row, index) => (
              <StyledTableRow key={index} className={styles.table_row}>
                <StyledTableCell
                  className={`${styles.delete_table_cell} ${styles.table_cell}`}
                >
                  <Tooltip title="Xóa">
                    <IconButton onClick={() => handelDeleteCartByID(row.id)}>
                      <DeleteIcon />
                    </IconButton>
                  </Tooltip>
                </StyledTableCell>

                <StyledTableCell
                  className={`${styles.img_table_cell} ${styles.table_cell}`}
                >
                  <img
                    src={row.imgPath}
                    className={styles.img_item}
                    alt="Item"
                  />
                </StyledTableCell>

                <StyledTableCell
                  align="left"
                  className={`${styles.table_cell}`}
                >
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    className={styles.title_responsive}
                  >
                    Tên:
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    {row.title}
                  </Typography>
                </StyledTableCell>
                <StyledTableCell
                  align="center"
                  className={`${styles.table_cell}`}
                >
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    className={styles.title_responsive}
                  >
                    Giá:
                  </Typography>
                  {row.priceDiscount ? toVND(row.priceDiscount) : toVND(row.price)}
                </StyledTableCell>
                <StyledTableCell
                  align="center"
                  className={`${styles.table_cell}`}
                >
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    className={styles.title_responsive}
                  >
                    Số Lượng:
                  </Typography>
                  <Grid container>
                    <Grid item xs={12} sm={12}>
                      <span className={`${styles.count_container}`}>
                        <Button
                          className={styles.btn_count}
                          size="large"
                          onClick={() => {
                            handelDeCreateByID(row.id);
                          }}
                        >
                          <RemoveIcon />
                        </Button>
                        <InputBase
                          className={styles.input_count}
                          value={row.count}
                        />
                        <Button
                          className={styles.btn_count}
                          size="large"
                          onClick={() => {
                            handelInCreateByID(row.id);
                          }}
                        >
                          <AddIcon />
                        </Button>
                      </span>
                    </Grid>
                  </Grid>
                </StyledTableCell>
                <StyledTableCell
                  align="left"
                  className={`${styles.table_cell}`}
                >
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    className={styles.title_responsive}
                  >
                    Tổng giá:
                  </Typography>
                  {toVND(row.count * row.priceDiscount)}
                </StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <div className={styles.btn_submit}>
        <Button
          variant="contained"
          color="primary"
          size="large"
          onClick={handleSubmit}
        >
          Tiến hành đặt hàng
        </Button>
      </div>
    </div>
  );
};

export default CartTable;
